module.exports = __webpack_public_path__ + "static/media/Jennifer Cooper.167f20b0.png";